import { Button } from 'antd-mobile';

// 悬浮按钮组组件
const FloatingButtons = ({ visible, buttons, buttonColors, onButtonClick }) => {
  if (!visible) return null;
  if (buttons.length === 0) return null;

  // 固定写死按钮图标
  // const iconArr = ['/images/ts2.png','/images/ms2.png','/images/cy2.png','/images/cz.png','/images/ly2.png','/images/yx2.png'];
  const iconArr = ['/images/ts3.png','/images/ms3.png','/images/cy3.png','/images/cz3.png','/images/ly3.png','/images/yx3.png'];
  // const iconArr = ['https://resources.eos-dongguan-1.cmecloud.cn/agri/ts2.png','https://resources.eos-dongguan-1.cmecloud.cn/agri/ms2.png','https://resources.eos-dongguan-1.cmecloud.cn/agri/cy2.png','https://resources.eos-dongguan-1.cmecloud.cn/agri/cz.png','https://resources.eos-dongguan-1.cmecloud.cn/agri/ly2.png','https://resources.eos-dongguan-1.cmecloud.cn/agri/yx2.png'];
  
  return (

    <div className="left-buttons">
        {
            buttons.map((item, index) => {
                return (
                <Button 
                    shape="circle" 
                    size="large" 
                    className="control-button"
                    onClick={() => onButtonClick(item)}
                    style={{
                      background: 'none',
                      boxShadow: 'none',
                      border: 'none',
                    }}
                    // style={{backgroundColor: item.color ?? buttonColors[index % buttonColors.length]}}
                >
                  {/* <div className="button-content"> */}
                <img 
                 src={iconArr[index]} 
                alt={item.name} 
                style={{ 
                  width: 60, 
                  height: 62,
                //   marginBottom: 3,
                  // filter: 'brightness(0) invert(1)'
                }} 
                onError={(e) => {
                  e.target.style.display = 'none';
                  const textEl = e.target.nextElementSibling;
                  if (textEl) textEl.style.marginBottom = 0;
                }}
              />
              {/* <span style={{
                // fontSize: '14px',
                // whiteSpace: 'nowrap',
                // lineHeight: 1.2
              }}>
                {item.name}
               </span> */}
               {/* </div> */}
                </Button>)
            })
        }
    </div>
    // <div className='left-buttons'>
    //   <div style={{
    //     display: 'flex',
    //     flexDirection: 'column',
    //     gap: '0.8rem',
    //     padding: '0.5rem 0',
    //   }}>
    //     {buttons.map((item, index) => {
    //       const isTeseButton = item.id === 'teseby';
    //       return (
    //         <button
    //           key={item.id}
    //           onClick={() => onButtonClick(item)}
    //           style={{
    //             width: '60px',
    //             height: '60px',
    //             borderRadius: '50%',
    //             backgroundColor: isTeseButton ? item.color : buttonColors[index % buttonColors.length],
    //             boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    //             border: '2px solid white',
    //             display: 'flex',
    //             flexDirection: 'column',
    //             alignItems: 'center',
    //             justifyContent: 'center',
    //             cursor: 'pointer',
    //             transition: 'transform 0.3s ease',
    //             color: 'white',
    //             padding: '0 5px',
    //           }}
    //           onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
    //           onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
    //           title={item.name}
    //         >
    //           <img 
    //             src={item.icon} 
    //             alt={item.name} 
    //             style={{ 
    //               width: 22, 
    //               height: 22,
    //               marginBottom: 3,
    //               filter: 'brightness(0) invert(1)'
    //             }} 
    //             onError={(e) => {
    //               e.target.style.display = 'none';
    //               const textEl = e.target.nextElementSibling;
    //               if (textEl) textEl.style.marginBottom = 0;
    //             }}
    //           />
    //           <span style={{
    //             fontSize: '14px',
    //             whiteSpace: 'nowrap',
    //             lineHeight: 1.2
    //           }}>
    //             {item.name}
    //           </span>
    //         </button>
    //       );
    //     })}
    //   </div>
    // </div>
  );
};
export default FloatingButtons;